<template>
    <div class="vx-col md:w-full">
        <vx-tooltip text="Phản hồi" position="top">
            <feather-icon icon="MessageCircleIcon" class="action-success mt-4"
                svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord" />
        </vx-tooltip>
    </div>
</template>

<script>
export default {
    name: 'CellRendererActions',
    methods: {
        editRecord() {
            this.$router.push(`/user/feedback-info?id=${this.params.data.id}`).catch(() => {
            })
        },
    }
}
</script>
